import { ODataSelect } from "../../../../Providers.Api/ODataQuery";

export class Delegates extends ODataSelect
{
    public Delegate_Id = "";
    public DelegateUser_Id = "";
    public DelegateDisplayName = "";
    public DelegateEmail = "";
    public DelegateUserName = "";
    public PrimaryDisplayName = "";
    public PrimaryEmail = "";

    public init(response: any, nodeId: number): Delegates
    {
        super.init(response, nodeId);
        return this;
    }
}

export class TicketedEvents extends ODataSelect
{
    public Node_Id = 0;
    public Booking_Id = "";
    public Event_Title = "";
    public Event_Short_Description = "";
    public Event_Description = "";
    public WebSite_URL = "";
    public Phone = "";
    public ImageURI = "";
    public Event_Date = "";
    public Event_Start_DateTime = "";
    public Event_End_DateTime = "";
    public Event_Capacity = 0;
    public IsWaitingList_Allowed = 0;
    public Ticket_Price = 0;
    public IsAttendees_CheckingIn = 0;
    public Event_Status = "";
    public Invite_Permission = "";

    public init(response: any, nodeId: number): TicketedEvents
    {
        super.init(response, nodeId);
        return this;
    }
}

export class BookingParty extends ODataSelect
{
    public Space_Id = "";
    public Visit_Id = "";
    public Booking_Id = "";
    public Node_Id = 0;
    public Record_Id = "";
    public Booking_Participant_Email = "";
    public Booking_Participant_Name = "";
    public Booking_Participant_Organisation = "";
    public Booking_Participant_Type = 0;
    public Booking_IsVisitor = 0;
}
